export default "__VITE_ASSET__Dl7b61Ut__"